import cn from 'classnames'
import React from 'react'
import { NavLink, useRouteMatch } from 'react-router-dom'

export default function SettingsTabs() {
    const { path } = useRouteMatch()

    return (
        <div className="tabs">
            <ul>
                <li style={{ cursor: 'pointer' }} className={cn({ 'is-active': path.startsWith('/settings/user') })}>
                    <NavLink to="/settings/user">Профил</NavLink>
                </li>

                <li style={{ cursor: 'pointer' }} className={cn({ 'is-active': path.startsWith('/settings/rent-category') })}>
                    <NavLink to="/settings/rent-category">Аренда-Категория</NavLink>
                </li>
                <li style={{ cursor: 'pointer' }} className={cn({ 'is-active': path.startsWith('/settings/building-category') })}>
                    <NavLink to="/settings/building-category">Дом-Категория</NavLink>
                </li>
                <li style={{ cursor: 'pointer' }} className={cn({ 'is-active': path.startsWith('/settings/tech-category') })}>
                    <NavLink to="/settings/tech-category">Бошқа-Категория</NavLink>
                </li>
                <li style={{ cursor: 'pointer' }} className={cn({ 'is-active': path.startsWith('/settings/total-expense-category') })}>
                    <NavLink to="/settings/total-expense-category">Умимий Чиқим Категория</NavLink>
                </li>

                <li style={{ cursor: 'pointer' }} className={cn({ 'is-active': path.startsWith('/users') })}>
                    <NavLink to="/users">Ходимлар</NavLink>
                </li>

                <li style={{ cursor: 'pointer' }} className={cn({ 'is-active': path.startsWith('/settings/secret-code') })}>
                    <NavLink to="/settings/secret-code">Махфий Код</NavLink>
                </li>
                <li style={{ cursor: 'pointer' }} className={cn({ 'is-active': path.startsWith('/settings/price') })}>
                    <NavLink to="/settings/price">Нархлар</NavLink>
                </li>
            </ul>
        </div>
    )
}
